import { useCheckoutStore } from '../checkoutStore';
import StepIndicator from '../StepIndicator';
import { ScheduledRadioOptions } from './ScheduledRadioOptions';

export function Step2(): React.ReactElement {
  const selectedStore = useCheckoutStore((state) => state.selectedStore);

  const isDisabled = !selectedStore;

  return (
    <>
      <StepIndicator disabled={isDisabled} index={2}>
        Zeit wählen
      </StepIndicator>

      <ScheduledRadioOptions disabled={isDisabled} />
    </>
  );
}
